module.exports = __webpack_public_path__ + "img/direction_cneter_w.7e87262e.png";